import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { extract } from '@app/core';
import { OauthComponent } from './oauth.component';

const routes: Routes = [
  { path: 'oauth', component: OauthComponent, data: { title: extract('Oauth') } }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
}) 

export class OauthRouteModule { }
